import { render, staticRenderFns } from "./printInvoiceFarmer.vue?vue&type=template&id=bcbfa648&"
import script from "./printInvoiceFarmer.vue?vue&type=script&lang=js&"
export * from "./printInvoiceFarmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VRow})
